"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountFlagsRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class AccountFlagsRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('account_flags');
    }
    getActiveFlags() {
        return this.get('/');
    }
}
exports.AccountFlagsRoutes = AccountFlagsRoutes;
//# sourceMappingURL=account_flags.js.map